var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blok)?_c('storyblok',{staticClass:"page story-page",attrs:{"blok":_vm.blok}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }